import { useEffect } from 'react';

/**
 * useOutsideClick
 *
 * @param ref - React ref to the element to detect outside clicks for
 * @param isActive - Whether the listener should be active
 * @param onOutsideClick - Callback to run when an outside click is detected
 * @param ignoreSelectors - Array of selectors to ignore (optional)
 */
function useOutsideClick(
    ref: React.RefObject<HTMLElement>,
    isActive: boolean,
    onOutsideClick: () => void,
    ignoreSelectors: string[] = [],
) {
    useEffect(() => {
        if (!isActive) return undefined;
        function handleClick(event: MouseEvent) {
            const target = event.target as HTMLElement;
            if (
                ref.current &&
                !ref.current.contains(target) &&
                !ignoreSelectors.some(sel => target.closest(sel))
            ) {
                onOutsideClick();
            }
        }
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [isActive, ref, onOutsideClick, ignoreSelectors]);
}

export default useOutsideClick;
